export default "/_next/static/assets/images/sprite.a377bcf44ee4c3fcb294c221db22e2f6.svg";